import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../Interceptor/interceptor";


export const stateApi = createApi({
    reducerPath: 'stateApi',
    baseQuery: baseApiQuery,
    tagTypes: ["posts"],
    endpoints: (builder) => ({
        getState: builder.query({
            query: () => ({
                url: 'getstate/1/',
                method: "GET",
            }),
            providesTags: ['posts']
        }),
    })
})

export const { useGetStateQuery } = stateApi